import gql from 'graphql-tag';

export const CALENDAR_CONTACT_OPTIONS = gql`
  query CalendarContactOptions($input: CalendarContactOptionsInput!) {
    dealActivity {
      result: calendarContactOptions(input: $input) {
        error
        success
        list {
          value
          label
        }
      }
    }
  }
`;
